function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("g", null, React.createElement("path", {
  fill: "#EBEDEE",
  d: "M228,136.8c0,8.395-6.806,15.2-15.2,15.2H15.2C6.805,152,0,145.194,0,136.8V15.2C0,6.805,6.805,0,15.2,0 h197.6c8.395,0,15.2,6.805,15.2,15.2V136.8z"
}), React.createElement("path", {
  fill: "#0054A4",
  d: "M212.743,0h-197.6C6.749,0,0,6.811,0,15.205V26h228V15.205C228,6.811,221.139,0,212.743,0z"
}), React.createElement("path", {
  fill: "#F39C12",
  d: "M212.743,152h-197.6C6.749,152,0,145.2,0,136.805V126h228v10.805C228,145.2,221.139,152,212.743,152z"
}), React.createElement("g", null, React.createElement("polyline", {
  fill: "#1B53AF",
  points: "90.797,100.117 98.732,50.996 111.416,50.996 103.481,100.117 90.797,100.117  "
}), React.createElement("path", {
  fill: "#1B53AF",
  d: "M149.49,52.199c-2.51-0.986-6.452-2.061-11.364-2.061c-12.541,0-21.369,6.667-21.441,16.211 c-0.079,7.062,6.3,11,11.108,13.346c4.941,2.405,6.602,3.944,6.583,6.096c-0.034,3.289-3.944,4.797-7.592,4.797 c-5.078,0-7.776-0.741-11.947-2.575l-1.632-0.782l-1.773,10.995c2.956,1.369,8.44,2.555,14.13,2.618 c13.328,0,21.988-6.586,22.09-16.778c0.046-5.6-3.334-9.843-10.654-13.348c-4.433-2.276-7.152-3.786-7.121-6.092 c0.002-2.042,2.297-4.228,7.266-4.228c4.148-0.066,7.152,0.891,9.492,1.888l1.138,0.562L149.49,52.199"
}), React.createElement("path", {
  fill: "#1B53AF",
  d: "M182.026,51.043h-9.803c-3.04,0-5.313,0.871-6.646,4.074l-18.837,45.016h13.323 c0,0,2.172-6.055,2.666-7.384c1.453,0,14.398,0.025,16.245,0.025c0.381,1.714,1.544,7.358,1.544,7.358h11.772L182.026,51.043  M166.38,82.702c1.052-2.825,5.053-13.731,5.053-13.731c-0.075,0.129,1.045-2.845,1.685-4.688l0.856,4.237 c0,0,2.436,11.725,2.937,14.183C174.936,82.702,168.855,82.702,166.38,82.702z"
}), React.createElement("path", {
  fill: "#1B53AF",
  d: "M80.158,51.036L67.742,84.524l-1.329-6.808c-2.314-7.844-9.514-16.345-17.569-20.605l11.355,42.962 l13.426-0.009l19.972-49.029H80.158"
}), React.createElement("path", {
  fill: "#F39C12",
  d: "M56.219,51.002H35.763l-0.167,1.018c15.917,4.07,26.447,13.89,30.817,25.697l-4.445-22.57 C61.201,52.034,58.973,51.111,56.219,51.002"
})));

var SvgPayVisa = function SvgPayVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "228px",
    height: "152px",
    viewBox: "0 0 228 152",
    preserveAspectRatio: "xMinYMin meet",
    enableBackground: "new 0 0 228 152",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPayVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pay-visa.9ba3aa83.svg";
export { ForwardRef as ReactComponent };